module.exports = __webpack_public_path__ + "img/clothing73.6a5edd0b.jpg";